/** SettPainter — 2D fist fighter silhouette. */
import { paintFighterBuffCues } from './paintFighterBuffCues.js';

export const SettPainter = {
  paint(ctx, _pos, radius, entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, Math.PI * 2);
    ctx.fillStyle = '#1f2937';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(-radius * 0.95, radius * 0.15, radius * 0.4, 0, Math.PI * 2);
    ctx.arc(radius * 0.95, radius * 0.15, radius * 0.4, 0, Math.PI * 2);
    ctx.fillStyle = '#f59e0b';
    ctx.fill();
    paintFighterBuffCues(ctx, radius, entity);
  }
};
